import { useTranslation } from 'react-i18next'

import { Badge, Typography } from '@percent/lemonade'

export function PublicBadge() {
  const { t } = useTranslation()

  return (
    <Badge variant="informative" testId="public-fundraiser-badge" shape="oval">
      <Typography>{t('workplace_giving.fundraiser.publicBanner.badge')}</Typography>
    </Badge>
  )
}
